<template>
    <div class="pm-right">
        <div class="header">
            <el-input :placeholder="$t('integration.please_upload_the_plan')" disabled v-model="dioForm.base64" style="width:146px;">
            </el-input>
            <el-upload
              class="upload-demo"
              ref="upload"
              action="https://"
              :http-request="
                                  file => {
                                      uploadFile(file);
                                  }
                              "
              :on-remove="handleRemove"
              :show-file-list="false"
              :on-change="onChange"
              accept=".jpg, .png, .JPG, .PNG"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :auto-upload="false"
            >
              <el-button slot="trigger" :disabled="!valueSwitch" :title="$t('integration.select_picture')">
                  <i class="el-icon-search" :style="valueSwitch ? 'color: var(--primary-color)' : 'color: rgb(170, 170, 170)'"></i>
              </el-button>
              <el-button :disabled="!dioForm.base64" :title="$t('integration.confirm_upload')" @click="submitUpload">
                  <i class="el-icon-upload" :style="valueSwitch ? 'color: var(--primary-color)' : 'color: rgb(170, 170, 170)'"></i>
              </el-button>
              <!-- <div slot="tip" class="el-upload__tip">{{$t('integration.only_jpg/png_files_can_be_uploaded_c__and_no_more_than_500kb')}}</div> -->
            </el-upload>
            <div style="margin-left: auto">
              <el-button :title="$t('integration.editing_mode')" @click="changeMoveFn()">
                <i class="el-icon-place" :style="!valueSwitch ? 'color: var(--primary-color)' : 'color: #f59a23'"></i>
              </el-button>
            </div>
        </div>
        <div class="formContent" ref="listContainer">
            <el-radio-group v-model="planInfoType" @change="handleRadioChange" fill="var(--primary-color)" style="width: 100%;display: flex;">
              <el-radio-button label="1" class="my-radio-button" style="flex: 1;">{{ $t('public.device') }}</el-radio-button>
              <el-radio-button label="2" class="my-radio-button" style="flex: 1;">{{ $t('public.table_carrier') }}</el-radio-button>
            </el-radio-group>
            <!-- 设备/监测点 -->
            <div class="dev-car-list">
                <div
                    v-if="planInfoType === PLAN_INFO_TYPE.DEVICE"
                    v-for="(item, index) in deviceList"
                    :key="index"
                    class="dev-car-item"
                    :class="{ selected: selectedItem && selectedItem.deviceId + '-' + selectedItem.deviceCatalog === item.deviceId + '-' + item.deviceCatalog }"
                    @click="selectItem(item, planInfoType)"
                    ref="deviceItems"
                >
                    <div class="dev-car-item-left">
                        <span>{{ item.deviceCode }}</span>
                        <span>{{ $t('integration.type') + ': ' + $t(equiIconConvert(item.deviceCatalog, item.deviceType).title) }}</span>
                    </div>
                    <div class="dev-car-item-right">
                        <i v-if="item.isPos" class="el-icon-delete" @click.stop="handleDeviceDel(item, planInfoType)" style="font-size: 35px;color: #fff"></i>
                    </div>
                </div>

                <div
                    v-if="planInfoType === PLAN_INFO_TYPE.CARRIER"
                    v-for="item in carrierList"
                    :key="item.id"
                    class="dev-car-item"
                    :class="{ selected: selectedItem && selectedItem.id === item.id }"
                    @click="selectItem(item, planInfoType)"
                    ref="carrierItems"
                >
                    <div class="dev-car-item-left">
                        <span>{{ item.keycode }}</span>
                        <span>{{ $t('integration.type') + ': ' + $t(carrierTypeConvert(item.typeId).title) }}</span>
                    </div>
                    <div class="dev-car-item-right">
                        <i v-if="item.isPos" class="el-icon-delete" @click.stop="handleCarrierDel(item, planInfoType)" style="font-size: 35px;color: #fff"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    sceneupload,
    sceneDelPos,
    scenePosMerge,
    sceneGetPlanDetail,
    saveDevicePosition, deleteDevicePosition
} from '@/api/modules/architecture.js'
import bus from '@/utils/bus.js';
import { DEVICE_TYPE_ICON_FN } from '@/utils/iconMatch.js';
import EquiInfo from '@/pages/home/component/Map/component/equiInfo.vue';
import resultHandle from '@/common/resultHandle';
import { carrierTypeConvert, equiIconConvert } from '@/utils/convert'
import { handlePlanData, PLAN_INFO_TYPE } from '@/utils/planUtil-mf.js'
export default {
    props: ['pmObj', 'carrierArray', 'carrierScene', 'deviceScene', 'treeObj', 'xy'],

    watch: {
        xy(newVal) {
            this.xpos = newVal.xpos.toFixed(2);
            this.ypos = newVal.ypos.toFixed(2);
        },
        pmObj(newVal) {
            this.valueSwitch = false;
            this.carrierPointList = (newVal && newVal.carrierPositionList) || [];
            this.devicePointList = (newVal && newVal.devicePositionList) || [];
            this.selectedItem = null
            this.$emit('info', null);
        }
    },
    computed: {
        PLAN_INFO_TYPE() {
            return PLAN_INFO_TYPE
        },
        rules() {
            return {};
        },
        carrierList() {
            return this.carrierScene.map(item => {
                    return {
                        isPos: this.carrierPointList?.some(item1 => item1.id === item.id),
                        ...item
                    }
                }
            )
        },
        deviceList() {
            return this.deviceScene.map(item => {
                    return {
                        isPos: this.devicePointList?.some(item1 => item1.id === item.deviceId + '-' + item.deviceCatalog),
                        ...item
                    }
                }
            )
        },
        pointList() {
            return this.planInfoType === PLAN_INFO_TYPE.DEVICE ? this.devicePointList : this.carrierPointList
        }
    },
    components: {
        EquiInfo
    },
    data() {
        return {
            xpos: '',
            ypos: '',
            fileList: [],
            valueSwitch: false,
            planInfoType: PLAN_INFO_TYPE.DEVICE,
            dioForm: {
                base64: ''
            },
            // 收缩
            value1: 0,
            min: -2,
            max: 2,
            // 状态
            statusIcon: '',
            statusTilte: '',
            abIcon: '',
            abTitle: '',
            // 根据载体查找对应的设备信息
            generateInfo: {},
            carrierPointList: [],
            devicePointList: [],
            selectedItem: null
        };
    },
    methods: {
        carrierTypeConvert,
        equiIconConvert,
        changeMoveFn() {
            this.selectedItem = null
            this.valueSwitch = !this.valueSwitch;
            this.$emit('info', null);
            bus.$emit('isEditFn', this.valueSwitch);
        },
        // 上传开始
        submitUpload() {
            this.$confirm($t('integration.this_operation_will_remove_all_monitoring_point_anchors_dot__are_you_sure_this_operation_q'))
                .then(() => {
                    this.$refs.upload.submit();
                    this.devicePointList = [];
                    this.carrierPointList = [];

                    bus.$emit('updatePmObjPoint', []);
                })
                .catch(() => {});
        },
        handleRemove(file, fileList) {
            this.dioForm.base64 = '';
        },
        onChange(file, fileList) {
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }
            this.dioForm.base64 = fileList[0].name;
        },
        beforeUpload(file) {
            console.log('file=', file)
            const types = ['image/jpg', 'image/png', 'image/JPG', 'image/PNG', 'image/jpeg',];
            const isImage = types.includes(file.type);
            const isLtSize = file.size / 1024 / 1024 < 20;
            if (!isImage) {
                this.$message.error($t('public.upload_img_tips1'));
                return false;
            }
            if (!isLtSize) {
                this.$message.error($t('public.upload_img_tips2'));
                return false;
            }
            return true;
        },
        getBase64(file) {
            return new Promise(function(resolve, reject) {
                const reader = new FileReader();
                let imgResult = '';
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imgResult = reader.result;
                };
                reader.onerror = function(error) {
                    reject(error);
                };
                reader.onloadend = function() {
                    resolve(imgResult);
                };
            });
        },
        uploadFile(content) {
            let base64;
            this.getBase64(content.file).then(res => {
                base64 = res;
            });
            const fd = new FormData();
            fd.append('uploadFile', content.file);
            fd.append('sceneId', this.treeObj.sceneId);
            fd.append('planId', this.pmObj.planId);
            sceneupload(fd)
                .then(async ({ state }) => {
                    await resultHandle(state);
                    // this.getPmContent();
                     this.pmObj.base64Path = base64;
                    bus.$emit('uploadFile', base64);
                })
                .finally(() => {});
        },
        // 上传结束
        formatTooltip(val) {
            switch (val) {
                case -2: {
                    return $t('integration.3_times_smaller');
                }
                case -1: {
                    return $t('integration.2x_smaller');
                }
                case 0: {
                    return $t('integration.normal_size');
                }
                case 1: {
                    return $t('integration.zoom_in_2x');
                }
                case 2: {
                    return $t('integration.zoom_in_3x');
                }
            }
        },
        typeFn(type, str) {
            switch (str) {
                case 'sensor': {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'icon');
                }
                case 'gateway': {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'icon');
                }
                case 'dispaly': {
                    return DEVICE_TYPE_ICON_FN('dispaly', type, 'icon');
                }
                case 'relay': {
                    return DEVICE_TYPE_ICON_FN('relay', type, 'icon');
                }
                default:
                    break;
            }
        },
        titleFn(type, str) {
            switch (str) {
                case 'sensor': {
                    return DEVICE_TYPE_ICON_FN('sensor', type, 'title');
                }
                case 'gateway': {
                    return DEVICE_TYPE_ICON_FN('gateway', type, 'title');
                }
                case 'dispaly': {
                    return DEVICE_TYPE_ICON_FN('dispaly', type, 'title');
                }
                case 'relay': {
                    return DEVICE_TYPE_ICON_FN('relay', type, 'title');
                }
                default:
                    break;
            }
        },
        // 传感器编号跳转历史数据
        historyFn(opt) {
            const { href } = this.$router.resolve({
                path: '/historyData',
                query: {
                    tagId: opt.tag,
                    id: opt.id,
                    probeValue: this.generateInfo.carrier.sampleValue ? this.generateInfo.carrier.sampleValue : {},
                    carrierName: this.generateInfo.carrier.keycode || '',
                    scopeName: '',
                    sensorWay: 1
                }
            });
            window.open(href, '_blank', 'height=1080,width=1280,top=100,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');
        },
        // 缩放
        changeZoomFn(value) {
            bus.$emit('zoomFn', value);
        },
        // 刷新
        refreshFn() {
            this.getPmContent(true);
        },
        getPmContent() {
            sceneGetPlanDetail({ sceneId: this.treeObj.sceneId }).then(({ result }) => {
                bus.$emit('refreshPoint', result.carrierPositionList || []);
            });
        },
        // 更改
        changeCarrierFn() {
            const carrierPosition = {
                abnormal: this.selectedItem.abnormal,
                carrierName: this.selectedItem.keycode,
                carrierStatus: this.selectedItem.status,
                carrierTypeId: this.selectedItem.typeId,
                carrierId: this.selectedItem.id,
                scenePlanId: this.pmObj.planId,
                xpos: '',
                ypos: ''
            }
            this.generateInfo = handlePlanData(carrierPosition, PLAN_INFO_TYPE.CARRIER)
            this.$emit('info', this.generateInfo || {});
        },
        // 定位
        handleCarrierLocation(val, type) {

          console.log("handleCarrierLocation  pmObj -> ",this.pmObj)


            this.selectItemChange(val, type)

          if (!this.pmObj.base64Path){
            this.$message.warning($t('integration.please_upload_the_plan'));
            return;
          }

            if (!this.xpos || !this.ypos) return this.$message.warning($t('integration.position_cannot_be_empty'));
            const query = {
                scenePlanId: this.pmObj.planId,
                carrierId: this.generateInfo.id,
                xpos: this.xpos,
                ypos: this.ypos
            };

            scenePosMerge(query).then(({ state }) => {
                if (state.code === 200) {
                    this.$message.success($t('integration.successful_positioning'));
                    this.generateInfo.xpos = query.xpos
                    this.generateInfo.ypos = query.ypos
                    this.generateInfo.obj.xpos = query.ypos;
                    this.generateInfo.obj.ypos = query.ypos;
                    const idx = this.carrierPointList.findIndex(item => item.id === this.generateInfo.id);
                    idx !== -1
                        ? this.carrierPointList.splice(idx, 1, this.generateInfo)
                        : this.carrierPointList.push(this.generateInfo);
                    bus.$emit('updatePmObjPoint', this.carrierPointList);
                } else {
                    this.$message.error(state.msg);
                }
            });
        },
        //  删除
        handleCarrierDel(val, type) {
            this.selectItemChange(val, type)
            if (!this.valueSwitch) return this.$message.warning($t('integration.deleting_fixed_points_needs_to_be_done_in_edit_mode'));
            if (!this.selectedItem) return this.$message.warning($t('integration.select_at_least_one_mount_to_remove'));
            this.$confirm(this.$t('public.tip_confirm'))
                .then(() => {
                    sceneDelPos({ planId: this.pmObj.planId, carrierId: this.selectedItem.id }).then(({ result, state }) => {
                        if (result && state.code === 200) {
                            this.$message.success($t('integration.successfully_deleted'));
                            this.carrierPointList = this.carrierPointList.filter(item => item.id !== this.selectedItem.id);
                            // bus.$emit('delPoint');
                            bus.$emit('updatePmObjPoint', this.carrierPointList);
                            bus.$emit('refreshPoint', this.carrierPointList || []);
                            this.$emit('info', this.generateInfo);
                        } else if (!result && state.code === 200) {
                            // 暂无可移除的监测点锚点
                            this.$message.warning($t('integration.there_are_no_removable_mounting_anchors'));
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        changeDeviceFn() {
            this.generateInfo = handlePlanData(this.selectedItem, PLAN_INFO_TYPE.DEVICE)
            this.$emit('info', this.generateInfo || {});
        },
        handleDeviceLocation(val, type) {
          console.log("handleDeviceLocation  pmObj -> ",this.pmObj)
          if (!this.pmObj.base64Path){
             this.$message.warning($t('integration.please_upload_the_plan'));
            return;
          }
            this.selectItemChange(val, type)
            if (!this.xpos || !this.ypos) return this.$message.warning($t('integration.position_cannot_be_empty'));
            const query = {
                scenePlanId: this.pmObj.planId,
                deviceCatalog: this.selectedItem.deviceCatalog,
                deviceId: this.selectedItem.deviceId,
                xpos: this.xpos,
                ypos: this.ypos

            };
            saveDevicePosition(query).then(({ state }) => {
                if (state.code === 200) {
                    this.$message.success($t('integration.successful_positioning'));
                    this.generateInfo.xpos = query.xpos;
                    this.generateInfo.ypos = query.ypos;
                    this.generateInfo.obj.xpos = query.ypos;
                    this.generateInfo.obj.ypos = query.ypos;
                    const idx = this.devicePointList.findIndex(item => item.id === this.generateInfo.id);
                    idx !== -1
                        ? this.devicePointList.splice(idx, 1, this.generateInfo)
                        : this.devicePointList.push(this.generateInfo);
                    bus.$emit('updatePmObjPoint', this.devicePointList);
                } else {
                    this.$message.error(state.msg);
                }
            });
        },
        handleDeviceDel(val, type) {
            this.selectItemChange(val, type)
            if (!this.valueSwitch) return this.$message.warning($t('integration.deleting_fixed_points_needs_to_be_done_in_edit_mode'));
            if (!this.selectedItem) return this.$message.warning($t('integration.select_at_least_one_mount_to_remove'));
            const query = {
                planeId: this.pmObj.planId,
                deviceCatalog: this.selectedItem.deviceCatalog,
                deviceId: this.selectedItem.deviceId
            };
            this.$confirm(this.$t('public.tip_confirm'))
                .then(() => {
                    deleteDevicePosition(query).then(({ result, state }) => {
                        if (result && state.code === 200) {
                            this.$message.success($t('integration.successfully_deleted'));
                            this.devicePointList = this.devicePointList.filter(item => item.id !== this.selectedItem.deviceId + '-' + this.selectedItem.deviceCatalog);
                            // bus.$emit('delPoint');
                            bus.$emit('updatePmObjPoint', this.devicePointList);
                            bus.$emit('refreshPoint', this.devicePointList || []);
                            this.$emit('info', this.generateInfo);
                        } else if (!result && state.code === 200) {
                            // 暂无可移除的监测点锚点
                            this.$message.warning($t('integration.there_are_no_removable_mounting_anchors'));
                        } else {
                            this.$message.error(state.msg);
                        }
                    });
                })
                .catch(() => {});
        },
        handleRadioChange() {
            this.selectedItem = null
            this.$emit('info', null);
            this.$emit('typeFn', this.planInfoType);
            bus.$emit('refreshPoint', this.pointList || []);
        },
        selectItemChange(val, type) {
            if (this.selectedItem === val) return
            this.selectedItem = val
            if (type === PLAN_INFO_TYPE.DEVICE) {
                this.changeDeviceFn()
            }
            if (type === PLAN_INFO_TYPE.CARRIER) {
                this.changeCarrierFn()
            }
        },
        selectItem(val, type) {
            if (this.selectedItem === val) {
                this.selectedItem = null
                this.$emit('info', null);
                return
            }
            this.selectItemChange(val, type)
        },
        /**
         * 滚动列表，使指定 item 滚动到可视区域
         * @param {Object} targetItem
         * @param {Number|String} type  PLAN_INFO_TYPE.DEVICE 或 CARRIER
         */
        scrollToItem(targetItem, type) {
            // 1. 选择对应的数据数组和 refs
            const list = type === this.PLAN_INFO_TYPE.DEVICE
                ? this.deviceList
                : this.carrierList;
            const refsArray = type === this.PLAN_INFO_TYPE.DEVICE
                ? this.$refs.deviceItems
                : this.$refs.carrierItems;

            // 2. 找到索引
            const idx = list.findIndex(item => {
                if (type === this.PLAN_INFO_TYPE.DEVICE) {
                    return item.deviceId === targetItem.deviceId
                        && item.deviceCatalog === targetItem.deviceCatalog;
                } else {
                    return item.id === targetItem.id;
                }
            });
            if (idx < 0) return;

            // 3. 在 DOM 更新后滚动
            this.$nextTick(() => {
                const el = Array.isArray(refsArray) ? refsArray[idx] : refsArray;
                const container = this.$refs.listContainer;
                if (!el || !container) return;

                /*
                    behavior（滚动行为）
                    'auto'	默认行为（瞬间滚动）
                    'smooth'	平滑滚动（动画）
                */
                /*
                    block（垂直对齐方式）
                    'start'	元素的顶部对齐容器的可视区域顶部（默认）
                    'center'	元素的中间对齐容器的可视区域中间
                    'end'	元素的底部对齐容器的可视区域底部
                    'nearest'	自动选择最小滚动距离的对齐方式（即尽量少滚动）
                */
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
        }
    },
    mounted() {
        bus.$on('changeCarrier', info => {
            this.dioForm.carrierId = info.carrierId;

            this.changeCarrierFn(info.carrierId);
        });

        bus.$on('position', info => {
            this.xpos = info.xpos;
            this.ypos = info.ypos;
            if (this.planInfoType === PLAN_INFO_TYPE.DEVICE) {
                this.handleDeviceLocation(this.selectedItem, this.planInfoType)
            } else {
                this.handleCarrierLocation(this.selectedItem, this.planInfoType)
            }
        });

        bus.$on('delPosition', info => {
            if (info.type === PLAN_INFO_TYPE.DEVICE) {
                const item = this.deviceList.find(item => item.deviceId + '-' + item.deviceCatalog === info.id)
                this.handleDeviceDel(item, this.planInfoType)
            } else {
                const item = this.carrierList.find(item => item.id === info.id)
                this.handleCarrierDel(item, this.planInfoType)
            }
        });

        bus.$on('selectItemFn', data => {
            let item
            if (data.type === PLAN_INFO_TYPE.DEVICE) {
                item = this.deviceList.find(item => item.deviceId + '-' + item.deviceCatalog === data.id)
            } else {
                item = this.carrierList.find(item => item.id === data.id)
            }
            this.selectItem(item, this.planInfoType)
            this.scrollToItem(item, this.planInfoType);
        });
    },
    beforeDestroy() {
        bus.$off('changeCarrier');
        bus.$off('position');
        bus.$off('delPosition');
        bus.$off('selectItemFn');
    }
};
</script>

<style lang="scss" scoped>
.pm-right {
    width: 300px;
    border: 1px solid $borderColor3;
    box-sizing: border-box;
    border-left: none;

    .header {
        height: 50px;
        width: 100%;
        padding: 10px;

        display: flex;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        border-bottom: 1px solid $borderColor3;
    }

    .formContent {
        width: 100%;
        height: calc(100% - 50px);
        padding: 10px;
        box-sizing: border-box;
        overflow: auto;

        ::v-deep .my-radio-button .el-radio-button__inner {
          display: block;
          width: 100%;
        }

        .dev-car-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding-top: 10px;

          .dev-car-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
            background-color: var(--primary-color);
            color: #fff;
            border-radius: 4px;
            cursor: pointer;

            .dev-car-item-left {
              display: flex;
              flex-direction: column;
              gap: 10px;
              flex: 1.5;
            }

            .dev-car-item-right {
              display: flex;
              justify-content: center;
              align-items: center;
              flex: 0.5;
            }
          }

          .dev-car-item.selected {
            background-color: rgb(245, 154, 35);
            color: white;
          }
        }

        .slider {
            width: 200px;
            margin-left: 10px;
        }

        .icon {
            cursor: pointer;
            margin-right: 10px;
            font-size: 16px !important;
        }

        .pmClass {
            display: flex;
            // // 隐藏自带的elementUI样式
            // ::v-deep .el-upload-list__item-name {
            //     display: none;
            // }
        }

        .device {
            padding-right: 10px;
            box-sizing: border-box;
        }

        .sampleValue,
        .deviceName,
        .temp,
        .hum,
        .gatway,
        .dispaly,
        .relay {
            display: flex;
            justify-content: space-between;
            align-items: center;

            i {
                margin-left: 10px;
                cursor: pointer;
            }

            .spanTitle {
                cursor: pointer;

                &:hover {
                    font-weight: bold;
                }
            }
        }

        .sampleValue {
            margin-right: 10px;
        }
    }

    .orange {
        color: orange;
    }

    .binglanse {
        color: #00b5fc;
    }
}
</style>
